export enum PaymentActionType {
    APPLY_PAYMENT_CONFIG = "APPLY_PAYMENT_CONFIG",
    SET_PAYMENT_STATUS = "SET_PAYMENT_STATUS",
}
